import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const ShiftDetailCard = ({ title, children }) => {
    return (React.createElement(Box, { sx: { p: { xs: 1, sm: 2 }, width: '100%', background: themeColors.surface.secondary }, "data-test": 'shift-detail-card' },
        React.createElement(Typography, { variant: 'subtitle2', sx: { pb: 1 }, "data-test": 'title' }, title),
        children));
};
